export default __webpack_public_path__ + "img/62539cac3000b8cb9499319b6f9a9e8f.svg";